var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var GET_CAST_VOTES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetCastVotes {\n        sequent_backend_cast_vote {\n            id\n            tenant_id\n            election_id\n            election_event_id\n            status\n        }\n    }\n"], ["\n    query GetCastVotes {\n        sequent_backend_cast_vote {\n            id\n            tenant_id\n            election_id\n            election_event_id\n            status\n        }\n    }\n"])));
var templateObject_1;
